import { useQuery } from '@apollo/client'
import { useApolloClients } from 'lib/apollo/apolloProvider'
import { GET_ROOM_VIEW_ROOMS } from '../graphql/query'
import {
  TGetRoomViewRoomsInput,
  TGetRoomViewRoomsResponse,
} from '../RoomView.types'
import { captureWarning } from 'lib/monitoring'

export const useGetRoomViewRooms = (variables: TGetRoomViewRoomsInput) => {
  const { iservicesClient: client } = useApolloClients()
  return useQuery<TGetRoomViewRoomsResponse, TGetRoomViewRoomsInput>(
    GET_ROOM_VIEW_ROOMS,
    {
      client,
      variables,
      fetchPolicy: 'no-cache',
      onError: (error: Error) => {
        captureWarning(error)
      },
    }
  )
}
